import React from 'react';

import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { useQuery, useMutation } from '@tanstack/react-query';
import * as Yup from 'yup';

import CrudForm from '../../../../components/Form/CrudForm';

import BrokerTeamService from '../../../../services/BrokerTeamService';

const fields = [
  {
    label: 'Team Name',
    type: 'text',
    name: 'name',
    placeholder: 'Type team name',
    validation: Yup.string().required('This field is required'),
    fullWidth: true,
  },
];

export default function AddOrEditTeamPage() {
  const navigate = useNavigate();

  const location = useLocation();
  const isCreate = location.pathname === '/settings/teams/create';

  const { id } = useParams();

  const { data: brokerTeam } = useQuery({
    queryKey: ['brokerTeam', id],
    queryFn: () => BrokerTeamService.getBrokerTeam(id),
    enabled: !!id,
  });

  const { mutate: createBrokerTeam } = useMutation({
    mutationFn: (formValues) => BrokerTeamService.createBrokerTeam(formValues),
    onSuccess: () => {
      navigate('/settings/teams');
    },
    onError: (error) => {
      console.log(error);
    },
  });

  const { mutate: updateBrokerTeam } = useMutation({
    mutationFn: (formValues) =>
      BrokerTeamService.updateBrokerTeam({ id, formValues }),
    onSuccess: () => {},
    onError: (error) => {
      console.log(error);
    },
  });

  return (
    <div>
      <CrudForm
        fields={fields}
        submitButtonLabel={isCreate ? 'Create' : 'Update'}
        createHandler={createBrokerTeam}
        updateHandler={updateBrokerTeam}
        data={brokerTeam}
      />
    </div>
  );
}
